<app-modal-shell [config]="modalConfig">
  <form modal-content [formGroup]="form" class="status-form" (ngSubmit)="onConfirm()">
    <mat-form-field appearance="fill" class="full-width">
      <mat-label>Estado</mat-label>
      <mat-select formControlName="status">
        <mat-option *ngFor="let option of statusOptions" [value]="option.value">
          {{ option.label }}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="form.get('status')?.hasError('required')">
        Selecciona un estado distinto al actual.
      </mat-error>
    </mat-form-field>

    <app-date-picker
      *ngIf="requiresDeathDate"
      class="full-width"
      label="Fecha de fallecimiento"
      formControlName="deathDate"
      [errorMessages]="{
        required: 'La fecha de fallecimiento es requerida.',
        matDatepickerParse: 'Ingresa una fecha valida.'
      }">
    </app-date-picker>
  </form>

  <ng-container modal-actions>
    <button mat-button type="button" (click)="onCancel()">Cancelar</button>
    <button mat-flat-button color="primary" type="button" [disabled]="form.invalid" (click)="onConfirm()">Guardar</button>
  </ng-container>
</app-modal-shell>
